import { useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import axios from 'axios'
import { persistOwnerEmailVerified } from '@/utils/owner-email-verification'

const BASE_URL = import.meta.env.VITE_API_BASE_URL

export default function ConfirmOwnerEmailPage() {
  const { token: tokenFromPath } = useParams<{ token?: string }>()
  const [searchParams] = useSearchParams()
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading')
  const [message, setMessage] = useState('Confirmando e-mail...')
  const [countdown, setCountdown] = useState<number | null>(null)

  useEffect(() => {
    const token = tokenFromPath || searchParams.get('token') || searchParams.get('t')
    if (!token) {
      setStatus('error')
      setMessage('Token de confirmação não informado.')
      return
    }

    axios
      .get(`${BASE_URL}/mail/verify-owner-email`, { params: { token } })
      .then(response => {
        const email = String(response.data?.data?.email ?? '').trim().toLowerCase()
        if (!email) {
          throw new Error('E-mail não encontrado no token.')
        }

        persistOwnerEmailVerified(email)
        setStatus('success')
        setMessage(`E-mail ${email} confirmado com sucesso. Esta janela será fechada.`)
        setCountdown(3)
      })
      .catch(error => {
        setStatus('error')
        setMessage(error?.response?.data?.message || error?.message || 'Não foi possível confirmar o e-mail.')
      })
  }, [searchParams, tokenFromPath])

  useEffect(() => {
    if (status !== 'success') {
      return
    }

    const closeAttempt = window.setTimeout(() => {
      window.close()
    }, 3000)

    return () => window.clearTimeout(closeAttempt)
  }, [status])

  useEffect(() => {
    if (countdown === null || countdown <= 0) {
      return
    }

    const interval = window.setInterval(() => {
      setCountdown(current => {
        if (current === null || current <= 1) {
          window.clearInterval(interval)
          return 0
        }

        return current - 1
      })
    }, 1000)

    return () => window.clearInterval(interval)
  }, [countdown])

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="w-full max-w-sm rounded-lg border bg-card p-6 text-center shadow-sm">
        <h1 className="text-lg font-semibold text-foreground">
          {status === 'loading' ? 'Confirmando e-mail' : status === 'success' ? 'Confirmação concluída' : 'Falha na confirmação'}
        </h1>
        <p className="mt-3 text-sm text-muted-foreground">{message}</p>
        {status === 'success' && (
          <p className="mt-2 text-xs text-muted-foreground">
            {countdown && countdown > 0 ? `Fechando em ${countdown}s...` : 'Se a janela não fechar, pode fechá-la manualmente.'}
          </p>
        )}
      </div>
    </div>
  )
}
